import { useState, memo } from "react"
import { ReactComponent as ArrowDropDownIcon } from 'assets/icons/arrow_drop_down.svg'
import { ReactComponent as ArrowDropUpIcon } from 'assets/icons/arrow_drop_up.svg'
import { motion, AnimatePresence } from "motion/react"
import { APP_CONFIG } from "constants/constants";

interface SidebarDropdownProps {
	children: React.ReactNode
	title: string
	icon?: React.ReactNode
	closeOnClick?: boolean
}

const SidebarDropdown: React.FC<SidebarDropdownProps> = ({ children, title, icon, closeOnClick }) => {
	const [isOpen, setIsOpen] = useState(false)

	const handleToggle = () => {
		setIsOpen(!isOpen)
	}

	const handleContentClick = () => {
		if (closeOnClick) {
			setIsOpen(false)
		}
	}

	const containerClasses = `
		mx-4
		mb-2
		rounded-md
		border
		border-gray-400
		bg-white
		overflow-hidden
	`
	const headerClasses = `
		grid
		grid-cols-[min-content_auto_min-content]
		h-10
		items-center
		px-4
		gap-2
		cursor-pointer
		text-base
		lg:hover:bg-blue-100
		[&>svg]:fill-black
	`
	const titleClasses = `whitespace-nowrap select-none text-black truncate`
	const iconClasses = "fill-black"

	return (
		<div className={containerClasses}>
			<div className={headerClasses} onClick={handleToggle}>
				{icon ? icon : null}
				<span className={titleClasses}>{title}</span>
				{isOpen ? <ArrowDropUpIcon className={iconClasses} /> : <ArrowDropDownIcon className={iconClasses} />}
			</div>
			<AnimatePresence>
				{isOpen && (
					<motion.div
						key="sidebar-dropdown"
						initial={{ height: '0px' }}
						animate={{
							height: 'auto',
							transition: { duration: APP_CONFIG.SHORT_ENTER_ANIMATION_DURATION }
						}}
						exit={{
							height: '0px',
							transition: { duration: APP_CONFIG.SHORT_EXIT_ANIMATION_DURATION }
						}}
						className="overflow-hidden"
						onClick={handleContentClick}
					>
						{children}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	)
}

export default memo(SidebarDropdown)
